// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"98":"5ed8301c","139":"d26124d0","194":"60add62d","224":"c5f56847","287":"622b73ee","308":"6079e83e","474":"20d0cd85","490":"f2bc851e","498":"9fb88195","528":"550b4bc6","738":"929052a6","909":"4e17aef9"}[chunkId] + ".chunk.js";
};